import { useEffect, useRef } from 'react';

interface UseSymbolsModalParams {
	isOpen: boolean;
}

interface UseSymbolsModalReturn {
	modalRef: React.RefObject<HTMLDivElement>;
}

/**
 * Custom hook to manage symbols modal positioning relative to PDF container
 * Positions modal at top-right of viewable PDF container area
 */
export const useSymbolsModal = ({ isOpen }: UseSymbolsModalParams): UseSymbolsModalReturn => {
	const modalRef = useRef<HTMLDivElement>(null);
	const MODAL_OFFSET = 20;

	useEffect(() => {
		const updatePosition = () => {
			if (modalRef.current) {
				const pdfContainer = document.getElementById('pdf-container');
				if (pdfContainer) {
					const containerRect = pdfContainer.getBoundingClientRect();
					// Position modal at top-right of viewable PDF container area
					modalRef.current.style.top = `${containerRect.top + MODAL_OFFSET}px`;
					modalRef.current.style.right = `${window.innerWidth - containerRect.right + MODAL_OFFSET}px`;
				}
			}
		};

		if (isOpen) {
			// Set initial position
			updatePosition();

			// Update position on scroll and resize
			const pdfContainer = document.getElementById('pdf-container');
			if (pdfContainer) {
				pdfContainer.addEventListener('scroll', updatePosition);
				window.addEventListener('resize', updatePosition);
				return () => {
					pdfContainer.removeEventListener('scroll', updatePosition);
					window.removeEventListener('resize', updatePosition);
				};
			}
		}
	}, [isOpen]);

	return {
		modalRef
	};
};
